// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

/**
 * Whether the camera should move to FRAME a highlighted set.
 *
 * The ONLY opt-out is an explicit `action: 'none'` — a chart bar click/hover or a dashboard metric click,
 * where the user is reading the chart and does not want the map to navigate.
 *
 * This deliberately does NOT consider a highlight's `ttlMs`. `ttlMs` governs only the auto-clear LIFETIME,
 * and BOTH tool highlights (show_on_map / delta_watch / audit_clearances / pole_storyboard / …) and chart
 * clicks set it. Gating framing on `ttlMs` conflated "transient" with "don't navigate" and left multi-feature
 * TOOL highlights drawn but never framed — they could sit entirely offscreen. Kept pure (no Esri imports) so
 * the decision is unit-testable in isolation.
 */
export const shouldFrameCamera = (action: string | undefined, totalFeatures: number): boolean =>
  totalFeatures >= 1 && action !== 'none';

export default shouldFrameCamera;
